var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Button, Headline, Panel } from '@empiriecom/module-components';
import React, { useState } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import NotificationProvider, { useNotificationContext, } from '@empiriecom/module-components/Notification/NotificationProvider';
import useConfig from '../../../../hooks/useConfig';
import { submitRegisterForm } from '../../HelperFunctions/submitRegisterForm';
import MailIcon from '../../../../AnimatedIcon';
import ConditionModal from './ConditionModal';
import NLForm from './Form';
var newsletterSubscribeTexts = defineMessages({
    privacyLink: {
        id: 'nlForm.privacyLink',
    },
    formDescription: {
        id: 'nlForm.formDescription',
    },
});
var StyledNewsletterForm = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  text-align: center;\n\n  > svg {\n    width: 7rem;\n    height: 7rem;\n  }\n\n  a {\n    font-size: 0.688rem;\n    margin-top: 1.75rem;\n    display: block;\n    text-decoration: underline;\n\n    &:last-child {\n      margin: 1rem 0 1.813rem 0;\n    }\n  }\n\n  &&& input {\n    border: 0px;\n    box-shadow: inset 0 0 0 1px ", ";\n\n    &:active,\n    &:focus {\n      box-shadow: inset 0 0 0 1px ", ";\n    }\n  }\n"], ["\n  width: 100%;\n  text-align: center;\n\n  > svg {\n    width: 7rem;\n    height: 7rem;\n  }\n\n  a {\n    font-size: 0.688rem;\n    margin-top: 1.75rem;\n    display: block;\n    text-decoration: underline;\n\n    &:last-child {\n      margin: 1rem 0 1.813rem 0;\n    }\n  }\n\n  &&& input {\n    border: 0px;\n    box-shadow: inset 0 0 0 1px ", ";\n\n    &:active,\n    &:focus {\n      box-shadow: inset 0 0 0 1px ", ";\n    }\n  }\n"])), function (_a) {
    var greyNormal = _a.theme.greyNormal;
    return greyNormal.color.normal;
}, function (_a) {
    var primary = _a.theme.primary;
    return primary.color.normal;
});
var StyledTeaserText = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 0.938rem;\n  margin: auto;\n  padding: 0 1rem;\n  max-width: 32rem;\n"], ["\n  font-size: 0.938rem;\n  margin: auto;\n  padding: 0 1rem;\n  max-width: 32rem;\n"])));
var StyledPanel = styled(Panel)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n  margin: 2.438rem 0 0.5rem 0;\n"], ["\n  background-color: ", ";\n  margin: 2.438rem 0 0.5rem 0;\n"])), function (_a) {
    var greyLight = _a.theme.greyLight;
    return greyLight.color.normal;
});
var StyledFormHint = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 0.75rem;\n  color: ", ";\n  text-align: left;\n  margin: 0 auto 2.5rem auto;\n  max-width: 33.5rem;\n  padding-left: 0.75rem;\n"], ["\n  font-size: 0.75rem;\n  color: ", ";\n  text-align: left;\n  margin: 0 auto 2.5rem auto;\n  max-width: 33.5rem;\n  padding-left: 0.75rem;\n"])), function (_a) {
    var global = _a.theme.global;
    return global.color.textDarkTransparent;
});
var FormButton = function (_a) {
    var setPage = _a.setPage, areaKey = _a.areaKey;
    var config = useConfig();
    var intl = useIntl();
    var pushNotification = useNotificationContext().pushNotification;
    return (React.createElement(Button, { "data-testid": "nlSubscribe-enabled", form: "subscribeForm", layout: "primary", size: "large", onClick: function (event) {
            event.preventDefault();
            submitRegisterForm({ setPage: setPage, pushNotification: pushNotification }, intl, config, areaKey);
        } },
        React.createElement(FormattedMessage, { id: "nlForm.emailBtn" })));
};
var Page1Subscribe = function (_a) {
    var setPage = _a.setPage, areaKey = _a.areaKey;
    var _b = useState(false), isFormValid = _b[0], setIsFormValid = _b[1];
    var intl = useIntl();
    return (React.createElement(NotificationProvider, null,
        React.createElement(StyledNewsletterForm, { "data-testid": "nlSubscribe" },
            React.createElement(MailIcon, { type: "subscribe" }),
            React.createElement(StyledTeaserText, null,
                React.createElement(Headline, { level: 3, element: "div" },
                    React.createElement(FormattedMessage, { id: "nlForm.formTitle" })),
                React.createElement("div", { 
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: intl.formatMessage(newsletterSubscribeTexts.formDescription),
                    } })),
            React.createElement(StyledPanel, null,
                React.createElement(NLForm, { setIsFormValid: setIsFormValid })),
            React.createElement(StyledFormHint, null,
                React.createElement(FormattedMessage, { id: "nlForm.requiredHint" })),
            isFormValid ? (React.createElement(FormButton, { setPage: setPage, areaKey: areaKey })) : (React.createElement(Button, { "data-testid": "nlSubscribe-disabled", form: "subscribeForm", layout: "primary", size: "large", disabled: true },
                React.createElement(FormattedMessage, { id: "nlForm.missingEmailBtn" }))),
            React.createElement(ConditionModal, null),
            React.createElement("a", { href: intl.formatMessage(newsletterSubscribeTexts.privacyLink) },
                React.createElement(FormattedMessage, { id: "nlForm.privacyHint" })))));
};
export default Page1Subscribe;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map